import { Component } from "react"

class MisskeyId extends Component{
    constructor(props){
        super(props)
        this.name = "Misskey ID"
    }
    validate(callbackDialog,requireCheck){
        if(requireCheck && String(this.props).trim().length === 0){
            callbackDialog("エラー",this.name + "は必須です。")
            return false
        }
        if(String(this.props).trim().length > 0){
            if(this.props.length > 15){
                callbackDialog("エラー",this.name + "は15文字以内にしてください。")
                return false
            }
            if(!/^[a-zA-Z0-9_]{1,15}$/.test(this.props)){
                callbackDialog("エラー",this.name + "の形式ではありません。")
                return false
            }
        }
        return true
    }
}

export default MisskeyId;